import moment from "moment";
import { Div, Ref, Text, Button, Line, PopupMenu } from "@tblabs/truffle";
import { TimeUtils } from "../../Utils/TimeUtils";


export class DateSlider extends Div
{
    constructor(dateRef: Ref<Date>, now = () => new Date())
    {
        super("DateSlider");

        const dateInput = new Text(dateRef, v => TimeUtils.FormattedDayHour(v as Date));

        if (this.IsInvalidDate(dateRef.value))
        {
            dateInput.Border(3, "#ff6565").BorderStyle("dashed").BorderRadius(16).PaddingLeft(8).PaddingRight(8);
        }

        this.Append(
            dateInput,
            new Line().Margin(4),
            new Button("d+").OnClick(() => dateRef.value = moment(dateRef.value).add(1, 'day').toDate()),
            new Button("d-").OnClick(() => dateRef.value = moment(dateRef.value).add(-1, 'day').toDate()),
            " : ",
            new Button("h+").OnClick(() => dateRef.value = moment(dateRef.value).add(1, 'hour').toDate()),
            new Button("h-").OnClick(() => dateRef.value = moment(dateRef.value).add(-1, 'hour').toDate()),
            " : ",
            new Button("m+").OnClick(() => dateRef.value = moment(dateRef.value).add(5, 'minute').toDate()),
            new Button("m-").OnClick(() => dateRef.value = moment(dateRef.value).add(-5, 'minute').toDate()),
          
            new PopupMenu({
                "Wczoraj": () => dateRef.value = moment().subtract(1, 'day').hour(0).minute(0).seconds(0).milliseconds(0).toDate(),
                "Teraz": () =>
                {
                    const nowTime = moment(now());
                    const minutes = nowTime.minute();
                    const roundedMinutes = Math.round(minutes / 15) * 15;
                    dateRef.value = nowTime.minute(roundedMinutes).seconds(0).milliseconds(0).toDate();
                },
                "Dzisiaj": () => dateRef.value = moment().hour(0).minute(0).seconds(0).milliseconds(0).toDate(),
                "Jutro": () => dateRef.value = moment().add(1, 'day').hour(0).minute(0).seconds(0).milliseconds(0).toDate(),
                "00:00": () => dateRef.value = moment(dateRef.value).hour(0).minute(0).seconds(0).milliseconds(0).toDate(),
                "null": () => dateRef.value = new Date(0),
            }, new Button("⋮").RemoveClass("uk-button").PaddingLeft(12).PaddingRight(12)).MarginLeft(16)
        );
    }

    private IsInvalidDate(date: Date): boolean
    {
        try
        {
            return isNaN(date.getTime());
        }
        catch (e)
        {
            return true;
        }
    }
}
